import _, { lowerCase } from 'lodash';
import { CustomAttributeOptionTranslations } from './customAttributesOptionTranslations';
import { CustomAttributeTranslationProperties } from './customAttributesTranslationProperties';

export class CustomAttributeOptionPropertiesData {

  // Properties
  public options: string[] | undefined;
  public optionTranslations: CustomAttributeOptionTranslations[] | undefined;

  // Add a new translatoin record for an option value
  public static addOptionTranslation(
    attr: CustomAttributeOptionPropertiesData | undefined,
    optionName: string,
    translations: CustomAttributeTranslationProperties[],
  ) : CustomAttributeOptionTranslations[] {

    const newOptTransList = attr?.optionTranslations?.filter((oT) => oT.option !== optionName)
      || new Array<CustomAttributeOptionTranslations>();

    const newTrans = new CustomAttributeOptionTranslations();
    newTrans.option = optionName;
    newTrans.translations = _.cloneDeep(translations);
    newOptTransList?.push(newTrans);

    return newOptTransList;
  }

  // Get the translated value if it exists...
  public static translateOption(
    attr: CustomAttributeOptionPropertiesData,
    optionName: string,
    lang: string,
  ) : string {

    const optTrans = attr.optionTranslations?.find((oT) => oT.option === optionName);
    const transRecord = optTrans?.translations?.find((t) => t.lang === lowerCase(lang));

    return transRecord?.value || optionName;
  }
}
